import { AfterViewInit, EventEmitter, OnInit } from '@angular/core';
import { GameService, TurnStepType } from '../game.service';
import { Tile } from './tile';
var BoardComponent = /** @class */ (function () {
    function BoardComponent(gameService) {
        this.gameService = gameService;
        this.discard = [];
        this.boardConstants = {
            minSpace: 12,
            maxSpace: 185,
            rowWidth: 11,
            colHeight: 17,
            heartStart: 1,
            heartEnd: 9,
            homeStart: 177,
            homeEnd: 185
        };
        this.startLocations = [178, 180, 182, 184];
        this.campStarts = [
            { top: '11.4%', left: '52.25%' },
            { top: '36.4%', left: '52.25%' },
            { top: '61.4%', left: '52.5%' },
            { top: '86.4%', left: '52.25%' }
        ];
        this.tileStyle = { width: '0', height: '0' };
        this.tilePlaced = new EventEmitter();
        this.tileRemoved = new EventEmitter();
    }
    BoardComponent.prototype.ngOnInit = function () {
        this.spaces = this.gameService.getBoard();
        this.tiles = this.gameService.getTiles();
        this.tiles = this.shuffle(this.tiles);
        for (var i = 0; i < this.players.length; i++) {
            this.players[i].startLocation = this.startLocations[i];
        }
    };
    BoardComponent.prototype.ngAfterViewInit = function () {
        this.tileStyle.width = document.getElementsByTagName('hotm-cards')[0].clientWidth + 'px';
        this.tileStyle.height = document.getElementsByTagName('hotm-cards')[0].clientHeight / 2 + 'px';
    };
    BoardComponent.prototype.shuffle = function (pile) {
        var newPile = [];
        while (pile.length)
            newPile.push(pile.splice(Math.floor(Math.random() * pile.length), 1)[0]);
        return newPile;
    };
    BoardComponent.prototype.drawTile = function () {
        if (!this.tiles.length)
            return;
        var tile = this.tiles[0];
        this.gameService.currentTile = tile;
        this.tiles.shift();
        // TODO: when there are no tiles left to draw
    };
    BoardComponent.prototype.validateTilePlacement = function (tile) {
        if (!tile.visible)
            return;
        for (var i = this.boardConstants.minSpace; i < this.boardConstants.maxSpace; i++) {
            this.spaces[i].valid = false;
            if (this.spaces[i].visible || this.spaces[i].locked)
                continue;
            var hasDoor = false;
            if (tile.doors.north) {
                if (this.spaces[i - this.boardConstants.rowWidth].doors.south)
                    hasDoor = true;
                else if (this.spaces[i - this.boardConstants.rowWidth].visible)
                    continue;
            }
            else if (this.spaces[i - this.boardConstants.rowWidth].doors.south)
                continue;
            if (tile.doors.east) {
                if (this.spaces[i + 1].doors.west)
                    hasDoor = true;
                else if (this.spaces[i + 1].visible)
                    continue;
            }
            else if (this.spaces[i + 1].doors.west)
                continue;
            if (tile.doors.south) {
                if (this.spaces[i + this.boardConstants.rowWidth].doors.north)
                    hasDoor = true;
                else if (this.spaces[i + this.boardConstants.rowWidth].visible)
                    continue;
            }
            else if (this.spaces[i + this.boardConstants.rowWidth].doors.north)
                continue;
            if (tile.doors.west) {
                if (this.spaces[i - 1].doors.east)
                    hasDoor = true;
                else if (this.spaces[i - 1].visible)
                    continue;
            }
            else if (this.spaces[i - 1].doors.east)
                continue;
            this.spaces[i].valid = hasDoor;
        }
        // TODO: when there are no valid places to put this tile
    };
    BoardComponent.prototype.validatePlayerMovement = function (distance, location) {
        if (location < this.boardConstants.minSpace || location > this.boardConstants.maxSpace)
            return;
        if (distance && this.spaces[location].visible) {
            this.spaces[location - this.boardConstants.rowWidth].valid = this.spaces[location].doors.north && this.spaces[location - this.boardConstants.rowWidth].doors.south;
            this.spaces[location + 1].valid = this.spaces[location].doors.east && this.spaces[location + 1].doors.west;
            this.spaces[location + this.boardConstants.rowWidth].valid = this.spaces[location].doors.south && this.spaces[location + this.boardConstants.rowWidth].doors.north;
            this.spaces[location - 1].valid = this.spaces[location].doors.west && this.spaces[location - 1].doors.east;
            this.validatePlayerMovement(distance - 1, location - this.boardConstants.rowWidth);
            this.validatePlayerMovement(distance - 1, location + 1);
            this.validatePlayerMovement(distance - 1, location + this.boardConstants.rowWidth);
            this.validatePlayerMovement(distance - 1, location - 1);
        }
        this.spaces[this.players[this.gameService.currPlayer].location].valid = false;
        // TODO: when there are no valid moves to make
    };
    BoardComponent.prototype.validateAdjacentMovement = function (location, diagonal) {
        if (location < this.boardConstants.minSpace || location > this.boardConstants.maxSpace)
            return;
        this.spaces[location - this.boardConstants.rowWidth].valid = this.spaces[location - this.boardConstants.rowWidth].visible;
        this.spaces[location + 1].valid = this.spaces[location + 1].visible;
        this.spaces[location + this.boardConstants.rowWidth].valid = this.spaces[location + this.boardConstants.rowWidth].visible;
        this.spaces[location - 1].valid = this.spaces[location - 1].visible;
        if (diagonal) {
            this.spaces[location - this.boardConstants.rowWidth - 1].valid = this.spaces[location - this.boardConstants.rowWidth - 1].visible;
            this.spaces[location - this.boardConstants.rowWidth + 1].valid = this.spaces[location - this.boardConstants.rowWidth + 1].visible;
            this.spaces[location + this.boardConstants.rowWidth - 1].valid = this.spaces[location + this.boardConstants.rowWidth - 1].visible;
            this.spaces[location + this.boardConstants.rowWidth + 1].valid = this.spaces[location + this.boardConstants.rowWidth + 1].visible;
        }
    };
    BoardComponent.prototype.validateTileRemoval = function () {
        var _loop_1 = function (i) {
            if (this_1.spaces[i].locked)
                return "continue";
            if (this_1.players.filter(function (player) { return player.location === i; }).length)
                return "continue";
            if (this_1.spaces[i].visible)
                this_1.spaces[i].valid = true;
        };
        var this_1 = this;
        for (var i = this.boardConstants.minSpace; i < this.boardConstants.maxSpace; i++) {
            _loop_1(i);
        }
        // TODO: when there are no valid tiles to remove
    };
    BoardComponent.prototype.clearValidity = function () {
        this.spaces.forEach(function (space) { return space.valid = false; });
    };
    BoardComponent.prototype.selectSpace = function (space, currIndex) {
        if (!space.valid)
            return;
        var currLevel = space.level;
        if (this.gameService.currentTile) {
            this.spaces[currIndex] = this.gameService.currentTile;
            this.spaces[currIndex].level = currLevel;
            this.clearValidity();
            this.tilePlaced.emit();
        }
        else if (this.gameService.turnStep === TurnStepType.move) {
            this.players[this.gameService.currPlayer].location = currIndex;
            this.moveAvatar();
            this.clearValidity();
            this.gameService.turnStep = (space.level === 0 ? TurnStepType.xpEnd : TurnStepType.drawCard);
        }
        else if (this.gameService.turnStep === TurnStepType.preCombat) {
            this.clearValidity();
            this.discard.unshift(space);
            this.spaces[currIndex] = new Tile(currLevel);
            for (var i = 0; i < this.players.length; i++) {
                if (this.players[i].campLocation === currIndex) {
                    this.players[i].campLocation = 0;
                    this.players[i].campStyle = this.campStarts[i];
                }
            }
            this.tileRemoved.emit();
        }
    };
    BoardComponent.prototype.moveAvatar = function () {
        this.players[this.gameService.currPlayer].avatarStyle = this.avatarLocation(this.players[this.gameService.currPlayer]);
    };
    BoardComponent.prototype.avatarLocation = function (player) {
        var space = document.getElementById('s' + ('000' + player.location).slice(-3));
        var avatar = document.getElementsByClassName('avatar')[0];
        return {
            top: (space.offsetTop + Math.floor(Math.random() * (space.clientHeight - avatar.clientHeight))) + 'px',
            left: (space.offsetLeft + Math.floor(Math.random() * (space.clientWidth - avatar.clientWidth))) + 'px'
        };
    };
    BoardComponent.prototype.moveCamp = function () {
        var currPlayer = this.players[this.gameService.currPlayer];
        currPlayer.campLocation = currPlayer.location;
        currPlayer.campStyle = this.campLocation(currPlayer);
    };
    BoardComponent.prototype.campLocation = function (player) {
        var space = document.getElementById('s' + ('000' + player.campLocation).slice(-3));
        var camp = document.getElementsByClassName('forwardCamp')[0];
        return {
            top: (space.offsetTop + (space.clientHeight - camp.clientHeight - 1)) + 'px',
            left: (space.offsetLeft + (space.clientWidth - camp.clientWidth - 1)) + 'px'
        };
    };
    return BoardComponent;
}());
export { BoardComponent };
